<template>
  <div id="app">
    <Header :failedNum="failedNum"></Header>
    <transition name="fade">
      <router-view />
    </transition>
    <Foot v-if="routers.indexOf(nowRouter) > -1"></Foot>
  </div>
</template>

<script>
import Header from "./components/Header";
import Foot from "./components/Foot";
import {mapActions} from 'vuex';
import { getToken } from "./libs/util";
// import {setMenu} from './libs/util';
export default {
  name: "App",
  data() {
    return {
      routers: ["./"],
      nowRouter: "",
      failedNum:''
    };
  },
  watch: {
    $route: {
      handler(newRouter) {
        this.nowRouter = "." + newRouter.path;
        if(getToken()){
          this.failedAmount()
        }
      },
      immediate: true,
    },
  },
  components: {
    Header,
    Foot,
  },
  methods:{
     ...mapActions([
      'failedAmountAction',//权限
    ]),
    // 角标
    failedAmount(){
      this.failedAmountAction().then(res=>{
        this.failedNum = res.data
      })
    },
    //  ...mapActions([
    //   'getMemberAuthorityAction',//权限
    // ]),
    // getMemberAuthority(){
    //   this.getMemberAuthorityAction({
    //     authorityType:'MENU'
    //   }).then(res=>{
    //     setMenu(res.data)
    //   })
    // },
  },
  mounted() {
    // this.getMemberAuthority()
    document.title = this.$t("title");

    this.$store.state.fullWidth =
      document.documentElement.clientWidth > 1440
        ? document.documentElement.clientWidth
        : 1440;

    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth; //实时屏幕宽度
        let fullWidth = window.fullWidth > 1440 ? window.fullWidth : 1440;
        this.$set(this.$store.state, "fullWidth", fullWidth);
        // console.log('this.$store.state.fullWidth',this.$store.state.fullWidth)
      })();
    };
  },
};
</script>

<style>
@import url("../src/assets/icon/icons.css");

#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans,
    Ubuntu, Cantarell, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f8f8f8;
  min-width: 1440px;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.common-justify-end {
  justify-content: flex-end;
}
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* 一开始隐藏 */
.common-rowUnder::-webkit-scrollbar {
  display: none;
}

/* 鼠标经过再显示 */
.common-rowUnder::-webkit-scrollbar {
  display: block;
  width: 6px;
  background-color: rgba(155, 154, 154, 0.25);
  border-radius: 10px;
  height: 6px;
}
* {
  scrollbar-color: rgba(45, 140, 240, 0.7) rgba(155, 154, 154, 0.25); /* 滑块颜色  滚动条背景颜色 */
  scrollbar-width: thin; /* 滚动条宽度有三种：thin、auto、none */
}
.common-flex-end {
  justify-content: flex-end;
}
.common-rowUnder::-webkit-scrollbar-thumb {
  background-color: rgba(45, 140, 240, 0.7);
  border-radius: 10px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.common-flex {
  display: flex;
}
.common-justify-around {
  justify-content: space-around;
}
.common-justify-between {
  justify-content: space-between;
}
.common-flex-wrap {
  flex-wrap: wrap;
}
.common-justify-center {
  justify-content: center;
}
.common-justify-end {
  justify-content: flex-end;
}
.common-align-center {
  align-items: center;
}

.common-column {
  flex-direction:column;
}
.common-hover:hover {
  opacity: 0.8;
  cursor: pointer;
}
.common-background {
  background-color: #2d8cf0;
}
.common-border-color {
  border: 1px solid #2d8cf0;
}
.common-font-color {
  color: #2d8cf0;
}
.common-hover-deep:hover {
  /* opacity: 0.8; */
  background-color: #f8f9fb;
  cursor: pointer;
}
.common-direction-column {
  flex-direction: column;
}
button {
  border: none;
  outline: none;
  cursor: pointer;
}
.common-line {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  width: 40px;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background: #0a4dcc;
}
.common-line::after {
  width: 0;
  height: 0;
  border-top: 4px solid #fff;
  border-left: 4px solid transparent;
  content: "";
  z-index: 9;
  position: absolute;
  bottom: 0;
  right: 0;
}
.common-line::before {
  content: "";
  z-index: 9;
  position: absolute;
  width: 0;
  height: 0;
  border-top: 4px solid #fff;
  border-right: 4px solid transparent;
  left: 0;
  bottom: 0;
}
input {
  outline: none;
  border: none;
}
* {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue